<template>
  <div>
    <label v-if="switchText" @click="switchAction" title="Click para editar" for="text-input">{{ textEdited }}</label>
    <input v-if="!switchText" id="text-iput" type="text" v-model="textEdited"
      @keydown.enter="switchAndSend"
      @keydown.esc="cancel">
    <img v-if="!switchText" src="@/assets/assinarEconfirmar.png" alt="Confirmar" :title="$t('confirmar')" @click="switchAndSend">
    <img v-if="!switchText" src="@/assets/cancel.png" alt="Cancelar" :title="$t('cancelar')" @click="cancel">
  </div>
</template>

<script>
  export default {
    name:"TextToInput",
    props: ["text"],
    data() {
      return {
        backup: this.text,
        textEdited: this.text,
        switchText: true,
        edited: false
      }
    },
    watch: {
      text(value){
        this.textEdited = value
      }
    },

    methods: {
      switchAction() {
        this.switchText = !this.switchText
      },

      cancel() {
        this.textEdited = this.backup
        this.switchText = !this.switchText
      },

      switchAndSend() {
        this.switchAction()
        this.sendText();
      },

      sendText(){
        this.backup = this.textEdited
        this.$emit("sendText", this.textEdited);
      }
    }
  }
</script>

<style scoped>
label {
  cursor: pointer;
  padding: 1px 2px;
  margin: 1.333px;
}

input {
  width: calc(100% - 50px);
}

img {
  width: 15px;
  cursor: pointer;
  margin-left: 10px;
}
</style>